import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import FieldTip from '../ui/FieldTip';

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

const PrivateEquityFields = ({ formData, onFieldChange }) => {
  const sharePrice = parseFloat(formData.share_price);
  const numShares = parseInt(formData.number_of_shares);
  const showCalculation = !isNaN(sharePrice) && !isNaN(numShares) && sharePrice > 0 && numShares > 0;
  const calculatedAmount = showCalculation ? sharePrice * numShares : 0;

  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="fund_manager" className="portfolio-input-label">Fund Manager</Label>
        <Input
          id="fund_manager"
          data-testid="fund-manager-input"
          placeholder="e.g. Vanguard, BlackRock"
          value={formData.fund_manager}
          onChange={(e) => onFieldChange('fund_manager', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="share_price" className="portfolio-input-label">Share Price<FieldTip field="share_price" /></Label>
        <Input
          id="share_price"
          data-testid="share-price-input"
          type="number"
          step="0.01"
          placeholder="e.g. 10.50"
          value={formData.share_price}
          onChange={(e) => onFieldChange('share_price', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="number_of_shares" className="portfolio-input-label">Number of Shares Acquired</Label>
        <Input
          id="number_of_shares"
          data-testid="number-of-shares-input"
          type="number"
          placeholder="e.g. 1000"
          value={formData.number_of_shares}
          onChange={(e) => onFieldChange('number_of_shares', e.target.value)}
          className="portfolio-input"
        />
      </div>
      
      {showCalculation && (
        <div className="space-y-2">
          <Label className="portfolio-input-label">Calculated Amount</Label>
          <div className="p-3 bg-emerald-50 border border-emerald-200 rounded-lg">
            <p className="text-emerald-800 font-mono font-medium">
              {formatCurrency(calculatedAmount)} = ${sharePrice} x {numShares} shares
            </p>
            <p className="text-xs text-emerald-600 mt-1">
              Amount Invested will be automatically calculated
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default PrivateEquityFields;
